import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'landing',
    component: () =>
      import(/* webpackChunkName: "landing" */ '@/module/Landing/Index'),
  },
  {
    path: '/landing',
    name: 'landing',
    component: () =>
      import(/* webpackChunkName: "landing" */ '@/module/Landing/Index'),
  },
  {
    path: '/landing2/:appId',
    name: 'landing2',
    component: () =>
      import(/* webpackChunkName: "landing2" */ '@/module/Landing/landing2'),
  },
  {
    path: '/landing3/:appId',
    name: 'landing3',
    component: () =>
      import(/* webpackChunkName: "landing2" */ '@/module/Landing/landing3'),
  },
  {
    path: '/home',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/module/Home/Index').catch(
        error => {
          console.error('Error loading home chunk:', error)
        },
      ),
  },
  {
    path: '/codescan',
    name: 'codescan',
    component: () =>
      import(/* webpackChunkName: "codescan" */ '@/module/Home/Index'),
  },
  {
    path: '/selectpage',
    name: 'selectpage',
    component: () =>
      import(/* webpackChunkName: "selectpage" */ '@/module/Selectpage/Index'),
  },
  {
    path: '/register',
    name: 'register',
    component: () =>
      import(/* webpackChunkName: "register" */ '@/module/Register/Index'),
  },
  {
    path: '/registeremail',
    name: 'registeremail',
    component: () =>
      import(
        /* webpackChunkName: "registeremail" */ '@/module/RegisterEmail/Index'
      ),
  },
  {
    path: '/termandcondition',
    name: 'TermAndCondition',
    component: () =>
      import(
        /* webpackChunkName: "TermAndCondition" */ '@/module/TermAndCondition/Index'
      ),
  },
  {
    path: '/editprofile',
    name: 'editprofile',
    component: () =>
      import(
        /* webpackChunkName: "editprofile" */ '@/module/Editprofile/Index'
      ),
  },
  {
    path: '/social',
    name: 'social',
    component: () =>
      import(/* webpackChunkName: "social" */ '@/module/Social/Index'),
  },
  {
    path: '/connecting/email',
    name: 'connectingemail',
    component: () =>
      import(
        /* webpackChunkName: "connectingemail" */ '@/module/ConnectSocial/ConnectEmail'
      ),
  },
  {
    path: '/unconnect/facebook',
    name: 'unconnectfacebook',
    component: () =>
      import(
        /* webpackChunkName: "unconnectfacebook" */ '@/module/ConnectSocial/UnConnectFacebook'
      ),
  },
  {
    path: '/unconnect/email',
    name: 'unconnectemail',
    component: () =>
      import(
        /* webpackChunkName: "unconnectemail" */ '@/module/ConnectSocial/UnConnectEmail'
      ),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/module/Profile/Index'),
  },
  {
    path: '/connectshopee',
    name: 'connectshopee',
    component: () =>
      import(
        /* webpackChunkName: "connectshopee" */ '@/module/Profile/ConnectShopee'
      ),
  },
  {
    path: '/connecttiktok',
    name: 'connecttiktok',
    component: () =>
      import(
        /* webpackChunkName: "connecttiktok" */ '@/module/Profile/ConnectTiktok'
      ),
  },
  {
    path: '/pdpa',
    name: 'pdpa',
    component: () =>
      import(/* webpackChunkName: "pdpa" */ '@/module/Pdpa/consent'),
  },
  {
    path: '/companycrm',
    name: 'companycrm',
    component: () =>
      import(
        /* webpackChunkName: "companycrm" */ '@/module/AutoRegister/Index'
      ),
  },
  {
    path: '/resetpassword',
    name: 'resetpassword',
    component: () =>
      import(
        /* webpackChunkName: "resetpassword" */ '@/module/ResetPassword/Index'
      ),
  },
  {
    path: '/history',
    name: 'history',
    component: () =>
      import(/* webpackChunkName: "history" */ '@/module/History/History'),
  },
  {
    path: '/history/:Id',
    name: 'history',
    component: () =>
      import(/* webpackChunkName: "history" */ '@/module/History/History'),
  },
  {
    path: '/myrewards',
    name: 'myrewards',
    component: () =>
      import(
        /* webpackChunkName: "myrewards" */ '@/module/MyRewards/MyRewards'
      ),
  },
  {
    path: '/package/:Id',
    name: 'RewardsDetail',
    component: () =>
      import(
        /* webpackChunkName: "RewardsDetail" */ '@/module/MyRewards/RewardsDetail'
      ),
  },
  {
    path: '/addressedit',
    name: 'addressedit',
    component: () =>
      import(
        /* webpackChunkName: "addressedit" */ '@/module/Address/AddressEdit'
      ),
  },
  {
    path: '/campaigndetail/:Id',
    name: 'campaigndetail',
    component: () =>
      import(
        /* webpackChunkName: "campaigndetail" */ '@/module/CampaignDetail/Index'
      ),
  },
  {
    path: '/detail/:Id',
    name: 'detail',
    component: () =>
      import(/* webpackChunkName: "detail" */ '@/module/CampaignDetail/Index'),
  },
  {
    path: '/landing/email',
    name: 'landingEmail',
    component: () =>
      import(
        /* webpackChunkName: "landingEmail" */ '@/module/Account/LandingEmail'
      ),
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/module/Account/Login'),
  },
  {
    path: '/loginOTP',
    name: 'loginOTP',
    component: () =>
      import(/* webpackChunkName: "loginOTP" */ '@/module/Account/LoginOTP'),
  },
  {
    path: '/loginOTP/otp',
    name: 'otp',
    component: () => import(/* webpackChunkName: "otp" */ '@/module/OTP/OTP'),
  },
  {
    path: '/verifyemail',
    name: 'verifyemail',
    component: () =>
      import(/* webpackChunkName: "verifyemail" */ '@/module/Home/Index'),
  },
  {
    path: '/ecomurl',
    name: 'ecomurl',
    component: () =>
      import(/* webpackChunkName: "ecomurl" */ '@/module/Ecomurl/Index'),
  },
  {
    path: '/limitotp',
    name: 'limitotp',
    component: () =>
      import(/* webpackChunkName: "limitotp" */ '@/module/OTP/LimitOTP'),
  },
  {
    path: '/earnpoint',
    name: 'earnpoint',
    component: () =>
      import(/* webpackChunkName: "earnpoint" */ '@/module/EarnPoint/Index'),
  },
  {
    path: '/inviter',
    name: 'inviter',
    component: () =>
      import(
        /* webpackChunkName: "inviter" */ '@/module/FriendsGetFriend/inviter'
      ),
  },
  {
    path: '/invitedList',
    name: 'invitedList',
    component: () =>
      import(
        /* webpackChunkName: "invitedList" */ '@/module/FriendsGetFriend/invitedList'
      ),
  },
  {
    path: '/acceptinvite/:refcode',
    name: 'acceptinvite',
    component: () =>
      import(
        /* webpackChunkName: "acceptinvite" */ '@/module/FriendsGetFriend/acceptinvite'
      ),
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: () =>
      import(
        /* webpackChunkName: "forgotpassword" */ '@/module/Account/ForgotPassword'
      ),
  },
  {
    path: '/missionhub',
    name: 'missionhub',
    component: () =>
      import(
        /* webpackChunkName: "missionhub" */ '@/module/MissionHub/MissionHub'
      ),
  },
  {
    path: '/createcard',
    name: 'createVDCard',
    component: () =>
      import(
        /* webpackChunkName: "createVDCard" */ '@/module/ValueDesign/CreateCard'
      ),
  },
  {
    path: '/createcard/physical',
    name: 'createPhysicalCard',
    component: () =>
      import(
        /* webpackChunkName: "createPhysicalCard" */ '@/module/ValueDesign/CreatePhysicalCard'
      ),
  },
  {
    path: '/mycard',
    name: 'myCard',
    component: () =>
      import(/* webpackChunkName: "myCard" */ '@/module/ValueDesign/MyCard'),
  },
  {
    path: '/mycard/card/:Id',
    name: 'cardDetail',
    component: () =>
      import(
        /* webpackChunkName: "cardDetail" */ '@/module/ValueDesign/CardDetail'
      ),
  },
  {
    path: '/mycard/card/history/:Id',
    name: 'cardHistory',
    component: () =>
      import(
        /* webpackChunkName: "cardHistory" */ '@/module/ValueDesign/History'
      ),
  },
  {
    path: '/mycard/card/topup/:Id',
    name: 'cardTopup',
    component: () =>
      import(/* webpackChunkName: "cardTopup" */ '@/module/ValueDesign/Topup'),
  },
  {
    path: '/PageNotFindConfig',
    name: 'PageNotFindConfig',
    component: () =>
      import(
        /* webpackChunkName: "PageNotFindConfig" */ '@/module/PageNotFindConfig/index'
      ),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: () =>
      import(
        /* webpackChunkName: "PageNotFound" */ '@/module/PageNotFound/pages/Index'
      ),
  },
]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
